import { Activity } from '@/@types/activity';
import { ActivityKindCd, NotificationKindCd } from '@/@types/constant';
import { Notification } from '@/@types/Notification';
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class CreateDisplayMessage extends Vue {
  /** アクティビティ */
  createActivityTitle(activity: Activity) {
    const accountName = activity.actionAccountName;
    let title = '';
    switch (activity.activityKindCd) {
      case ActivityKindCd.addTask:
        title = `${accountName}さんが課題を追加`;
        break;
      case ActivityKindCd.updateTask:
        title = `${accountName}さんが課題を更新`;
        break;
      case ActivityKindCd.chargeTask:
        title = `${accountName}さんが課題を更新`;
        break;
      case ActivityKindCd.practiceTask:
        title = `${accountName}さんが課題を更新`;
        break;
      case ActivityKindCd.addTaskComment:
        title = `${accountName}さんが課題にコメント`;
        break;
      case ActivityKindCd.addMember:
        title = `${accountName}さんがメンバーを追加`;
        break;
      case ActivityKindCd.leaveMember:
        title = `${accountName}さんがメンバーを離任`;
        break;
    }
    return title;
  }

  createActivitySubjectName(activity: Activity) {
    let subjectName = '';
    if (
      activity.activityKindCd === ActivityKindCd.addTask ||
      activity.activityKindCd === ActivityKindCd.updateTask ||
      activity.activityKindCd === ActivityKindCd.chargeTask ||
      activity.activityKindCd === ActivityKindCd.practiceTask ||
      activity.activityKindCd === ActivityKindCd.addTaskComment
    ) {
      subjectName = `${activity.projectName}-${activity.taskId}`;
    } else if (
      activity.activityKindCd === ActivityKindCd.addMember ||
      activity.activityKindCd === ActivityKindCd.leaveMember
    ) {
      subjectName = activity.projectName;
    } else {
      // TODO: プルリクエスト機能などが追加されたら修正する
    }
    return subjectName;
  }

  createActivityMessage(activity: Activity) {
    let message = '';
    switch (activity.activityKindCd) {
      case ActivityKindCd.addTask:
        message = `${activity.taskName}`;
        break;
      case ActivityKindCd.updateTask:
        message = `${activity.taskName}`;
        break;
      case ActivityKindCd.chargeTask:
        message = `${activity.taskName}`;
        break;
      case ActivityKindCd.practiceTask:
        message = `${activity.taskName}`;
        break;
      case ActivityKindCd.addTaskComment:
        message = `${activity.taskName}`;
        break;
    }
    return message;
  }

  createActivityContent(activity: Activity) {
    if (activity.commentContent !== null) {
      return activity.commentContent;
    } else {
      return activity.activityMessage;
    }
  }

  /** 通知 */
  createNotificationTitle(notification: Notification) {
    const accountName = notification.actionAccountName;
    let title = '';
    switch (notification.notificationKindCd) {
      case NotificationKindCd.addTask:
        title = `${accountName}さんが課題を追加`;
        break;
      case NotificationKindCd.updateTask:
        title = `${accountName}さんが課題を更新`;
        break;
      case NotificationKindCd.chargeTask:
        title = `${accountName}さんが課題を更新`;
        break;
      case NotificationKindCd.practiceTask:
        title = `${accountName}さんが課題を更新`;
        break;
      case NotificationKindCd.addTaskComment:
        title = `${accountName}さんが課題にコメント`;
        break;
      case NotificationKindCd.addMember:
        title = `${accountName}さんがメンバーを追加`;
        break;
      case NotificationKindCd.leaveMember:
        title = `${accountName}さんがメンバーを離任`;
        break;
    }
    return title;
  }

  createNotificationSubjectName(notification: Notification) {
    let subjectName = '';
    if (
      notification.notificationKindCd === NotificationKindCd.addTask ||
      notification.notificationKindCd === NotificationKindCd.updateTask ||
      notification.notificationKindCd === NotificationKindCd.chargeTask ||
      notification.notificationKindCd === NotificationKindCd.practiceTask ||
      notification.notificationKindCd === NotificationKindCd.addTaskComment
    ) {
      subjectName = `${notification.projectName}-${notification.taskId}`;
    } else if (
      notification.notificationKindCd === NotificationKindCd.addMember ||
      notification.notificationKindCd === NotificationKindCd.leaveMember
    ) {
      subjectName = notification.projectName;
    } else {
      // TODO: プルリクエスト機能などが追加されたら修正する
    }
    return subjectName;
  }

  createNotificationMessage(notification: Notification) {
    let message = '';
    switch (notification.notificationKindCd) {
      case NotificationKindCd.addTask:
        message = `${notification.taskName}`;
        break;
      case NotificationKindCd.updateTask:
        message = `${notification.taskName}`;
        break;
      case NotificationKindCd.chargeTask:
        message = `${notification.taskName}`;
        break;
      case NotificationKindCd.practiceTask:
        message = `${notification.taskName}`;
        break;
      case NotificationKindCd.addTaskComment:
        message = `${notification.taskName}`;
        break;
    }
    return message;
  }

  createNotificationContent(notification: Notification) {
    if (notification.commentContent !== null) {
      return notification.commentContent;
    } else {
      return notification.notificationMessage;
    }
  }
}
